import { Button } from "@/components/ui/button";
import { labelPlural } from "@/utils/copyTituloBilhete";
import { QUANTIDADES_PRESET_COMPRA_RAPIDA } from "@/utils/compraRapida";
import { Minus, Plus } from "lucide-react";

interface QuantidadeCompraRapidaProps {
    quantidade: number;
    onChange: (quantidade: number) => void;
    size?: "sm" | "lg";
}

export function CardsQuantidadePresetCompraRapida({
    quantidade,
    onChange,
    size = "lg",
}: QuantidadeCompraRapidaProps) {
    const isLarge = size === "lg";

    return (
        <div className="flex flex-wrap justify-center gap-3">
            {QUANTIDADES_PRESET_COMPRA_RAPIDA.map((qtd) => (
                <Button
                    key={`preset-qtd-${qtd}`}
                    variant={quantidade === qtd ? "default" : "foreground"}
                    onClick={() => onChange(qtd)}
                    size={isLarge ? "lg" : "sm"}
                >
                    {qtd} {labelPlural()}
                </Button>
            ))}
        </div>
    );
}

export function StepperQuantidadeCompraRapida({
    quantidade,
    onChange,
    size = "lg",
}: QuantidadeCompraRapidaProps) {
    const isLarge = size === "lg";

    return (
        <div className="flex items-center justify-center gap-3">
            <Button
                disabled={quantidade === 1}
                onClick={() => {
                    if (quantidade === 1) {
                        return;
                    }
                    onChange(quantidade - 1);
                }}
                size={isLarge ? "lg" : "sm"}
                variant="outline"
            >
                {isLarge ? <Minus size="20" /> : "-"}
            </Button>
            {isLarge ? (
                <span className="flex flex-col select-none justify-center items-center text-primary text-sm font-semibold">
                    <span>{quantidade}</span>
                    <span>{labelPlural()}</span>
                </span>
            ) : (
                <Button size="sm" variant="outline">
                    {quantidade}
                </Button>
            )}
            <Button
                onClick={() => onChange(quantidade + 1)}
                size={isLarge ? "lg" : "sm"}
                variant="outline"
            >
                {isLarge ? <Plus size="20" /> : "+"}
            </Button>
        </div>
    );
}

export function SeletorQuantidadeCompraRapida({
    quantidade,
    onChange,
    size = "lg",
}: QuantidadeCompraRapidaProps) {
    return (
        <div className="flex flex-col items-center gap-3">
            <CardsQuantidadePresetCompraRapida
                quantidade={quantidade}
                onChange={onChange}
                size={size}
            />
            <StepperQuantidadeCompraRapida
                quantidade={quantidade}
                onChange={onChange}
                size={size}
            />
        </div>
    );
}
